import React from "react";
import { convertTimeIntoHourMin, getRole } from "../utils/generic";
import styled from "styled-components";

const MessageMultiChoice = styled.div`
  max-width: 480px;
  .buttonStyle {
    // border: 0.5px solid #1b255924;
    background: #28a6de;
    color: #fff;
    border-radius: 20px;
    /* font-family: Plus Jakarta Sans; */
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    cursor: default;
    opacity: 1 !important;
  }
`;

const MultiChoice = ({ message }) => {
  if (message && message.content) {
    return (
      <MessageMultiChoice>
        <p className="msg" style={{ whiteSpace: "pre-wrap" }}>
          {message.content.text}
        </p>

        {message.content.options &&
          message.content.options.map((option, index) => {
            return (
              <button
                key={index}
                className={`btn btn-outline-primary m-1 flex-grow-1 buttonStyle`}
                disabled
              >
                {option.title || ""}
              </button>
            );
          })}
        {/* <div className="message-info-td">
          <span className="message-time">{convertTimeIntoHourMin(message.timeStamp)}</span>
          <span className="material-symbols-outlined message-deliver">done_all</span>
        </div> */}
      </MessageMultiChoice>
    );
  } else {
    return <div></div>;
  }
};
export default MultiChoice;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/MultiChoice.jsx